import Footer from "../Component/Footer";
import Header from "../Component/Header";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";

const AdmissionList = () => {
  return (
    <>
      <Header />
      <Breadcrumb pageTitle="Admission" breadcrumbName="Admission" />
      <div className="container toppad-30 margin_tb">
        <div className="row">
          <div className="col-lg-4 col-md-6">
            <div className="admission_blk">
              <Link to="https://webapi.entab.info/api/image/AFGJI/public/pdf/NAF-KG-2.pdf" 
              target="_blank">
                <LazyLoad>
                  <img
                    src="https://webapi.entab.info/api/image/AFGJI/public/Images/pdf.png"
                    className="img-fluid"
                  />
                </LazyLoad>
                KG NAF SECOND LIST ALONG WITH WAITING LIST 2026-27
              </Link>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="admission_blk">
              <Link
                to="https://webapi.entab.info/api/image/AFGJI/public/pdf/new-ad.pdf"
                target="_blank"
              >
                <LazyLoad>
                  <img
                    src="https://webapi.entab.info/api/image/AFGJI/public/Images/pdf.png"
                    className="img-fluid"
                  />
                </LazyLoad>
                ADMISSION NOTICE FOR WARDS OF SERVING AIR FORCE PERSONNEL IN
                AFBBS/ TAFS/AFGJI: ACADEMIC YEAR 2026-27
              </Link>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="admission_blk">
              <Link
                to="https://webapi.entab.info/api/image/AFGJI/public/pdf/KG-2026-27.pdf"
                target="_blank"
              >
                <LazyLoad>
                  <img
                    src="https://webapi.entab.info/api/image/AFGJI/public/Images/pdf.png"
                    className="img-fluid"
                  />
                </LazyLoad>
                KG NAF FIRST LIST ALONG WITH WAITING LIST 2026-27
              </Link>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="admission_blk">
              <Link
                to="https://webapi.entab.info/api/image/AFGJI/public/pdf/NAF-2026-27.pdf"
                target="_blank"
              >
                <LazyLoad>
                  <img
                    src="https://webapi.entab.info/api/image/AFGJI/public/Images/pdf.png"
                    className="img-fluid"
                  />
                </LazyLoad>
                NURSERY(BALBATIAK-1PRE SCHOOL-1) NAF FIRST LIST ALONG WITH
                WAITING LIST 2026-27
              </Link>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="admission_blk">
              <Link
                to="https://webapi.entab.info/api/image/AFGJI/public/pdf/KG_2026_2027_withPoints.pdf"
                target="_blank"
              >
                <LazyLoad>
                  <img
                    src="https://webapi.entab.info/api/image/AFGJI/public/Images/pdf.png"
                    className="img-fluid"
                  />
                </LazyLoad>
                LIST OF CHILDREN WHO APPLIED FOR ADMISSION IN CLASS KG NAF
                CATEGORY WTIH POINTS AY 2026-27
              </Link>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="admission_blk">
              <Link
                to="https://webapi.entab.info/api/image/AFGJI/public/pdf/NUR_WithPoints_2026_2027.pdf"
                target="_blank"
              >
                <LazyLoad>
                  <img
                    src="https://webapi.entab.info/api/image/AFGJI/public/Images/pdf.png"
                    className="img-fluid"
                  />
                </LazyLoad>
                LIST OF CHILDREN WHO APPLIED FOR ADMISSION IN CLASS NURSERY (BAL
                VATIKA -1/PRE SCHOOL-1) NAF CATEGORY WTIH POINTS AY 2026-27
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="admission_blk">
              <Link
                to="https://webapi.entab.info/api/image/AFGJI/public/pdf/KG_2026_2027.pdf"
                target="_blank"
              >
                <LazyLoad>
                  <img
                    src="https://webapi.entab.info/api/image/AFGJI/public/Images/pdf.png"
                    className="img-fluid"
                  />
                </LazyLoad>
                LIST OF CHILDREN WHO APPLIED FOR ADMISSION IN CLASS KG NAF
                CATEGORY WTIHOUT POINTS AY 2026-27.
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="admission_blk">
              <Link
                to="https://webapi.entab.info/api/image/AFGJI/public/pdf/NUR_2026_2027.pdf"
                target="_blank"
              >
                <LazyLoad>
                  <img
                    src="https://webapi.entab.info/api/image/AFGJI/public/Images/pdf.png"
                    className="img-fluid"
                  />
                </LazyLoad>
                LIST OF CHILDREN WHO APPLIED FOR ADMISSION IN CLASS NURSERY (BAL
                VATIKA -1/PRE SCHOOL-1) NAF CATEGORY WTIHOUT POINTS AY 2026-27
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="admission_blk">
              <Link
                to="https://webapi.entab.info/api/image/AFGJI/public/pdf/NURSERY-PRE SCHOOL-KGADMISSION-SCHEDULE-2026-27.pdf"
                target="_blank"
              >
                <LazyLoad>
                  <img
                    src="https://webapi.entab.info/api/image/AFGJI/public/Images/pdf.png"
                    className="img-fluid"
                  />
                </LazyLoad>
                ADMISSION SCHEDULE FOR NURSERY (BAL VATIKA-1/PRE- SCHOOL-1) AND
                KG : 2026-27 FOR NON AIR FORCE CATEGORY.
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="admission_blk">
              <Link
                to="https://webapi.entab.info/api/image/AFGJI/public/pdf/Notice-regarding-admissions-XI-2025-26.pdf"
                target="_blank"
              >
                <LazyLoad>
                  <img
                    src="https://webapi.entab.info/api/image/AFGJI/public/Images/pdf.png"
                    className="img-fluid"
                  />
                </LazyLoad>
                Notice regarding admissions for Class XI for the academic
                session 2025-26
              </Link>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="admission_blk">
              <Link
                to="https://webapi.entab.info/api/image/AFGJI/public/pdf/XI-STREAM-ALLOCATION-2025-26.pdf"
                target="_blank"
              >
                <LazyLoad>
                  <img
                    src="https://webapi.entab.info/api/image/AFGJI/public/Images/pdf.png"
                    className="img-fluid"
                  />
                </LazyLoad>
                CLASS XI STREAM ALLOCATION 2025-26
              </Link>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="admission_blk">
              <Link
                to="https://webapi.entab.info/api/image/AFGJI/public/pdf/XI-PROVISIONAL-STREAM-ALLOCATION2025-26.pdf"
                target="_blank"
              >
                <LazyLoad>
                  <img
                    src="https://webapi.entab.info/api/image/AFGJI/public/Images/pdf.png"
                    className="img-fluid"
                  />
                </LazyLoad>
                CLASS XI PROVISIONAL STREAM ALLOCATION 2025-26
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default AdmissionList;
